module.exports = __webpack_public_path__ + "static/mountain-splash-400x2000-656c0bebafbbef10ebdb12972b79870e.jpg";